module.exports = __webpack_public_path__ + "static/media/nature_hover.eff77975.jpg";